//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('workGrps', {
//        templateUrl: 'views/components/views/workGrps/workGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'workGrpsService', function (stateService, workGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCapacityGroups: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadWorkGroupsView() {
//                vm.model.itemsListCapacityGroups = (await workGrpsService.listWorkGroupsView());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'workgrp':
//                        go({ workgrp_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadWorkGroupsView();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
